module.exports = __webpack_public_path__ + "img/curved-rail-horizontal-left-top-ties-remnants.65bdccc6.png";